/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-15 16:01:48
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-26 13:52:59
 * @FilePath: \ioc_base\src\modules\personMg\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [{
    path: '/personMg', // 人员名单管理
    name: 'personMg',
    component: () => import('./view/personMgNew.vue'),
    meta: {
      requireAuth: false,
      routerAlive: true
    },
  },
  // {
  //   path: '/personMgNew', // 人员名单管理
  //   name: 'personMg',
  //   component: () => import('./view/personMgNew.vue'),
  //   meta: {
  //     requireAuth: false,
  //     routerAlive: true
  //   },
  // },
]

export default routes